module.exports = __webpack_public_path__ + "static/media/Cardo-Bold.d99cc1bc.svg";